// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__z4dxb","type":"styles_type__8pGOK","choices":"styles_choices__2p4h3"};